export class ClienteModel {
    cod_cliente?: number;
    nome_fantasia?:string
    nome?:string
    tipo_end?:string
    end_rps?:string
    numero?:string
    contrato?:string
    cnpj?:string
    visita?: string

    login?:string
    senha_nova?:string

    filtro_data_inicial:Date
    filtro_data_final:Date
    filtro_visita?: string
    filtro_elevador?: string
}
